module.exports = __webpack_public_path__ + "static/media/ai.c5749321.svg";